// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-persons-to-visit-table {
  margin-bottom: 10px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #e9ecef;
}

.table-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.add-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s;
}

.add-btn:hover {
  background: #218838;
}

.empty-state {
  text-align: center;
  padding: 30px 20px;
  border: 2px dashed #e9ecef;
  border-radius: 8px;
  background: #f8f9fa;
}

.empty-state p {
  margin: 0 0 15px 0;
  color: #666;
  font-size: 14px;
}

.table-footer {
  padding: 15px 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
}

.hint-text {
  margin: 0 0 10px 0;
  color: #6c757d;
  font-size: 14px;
  font-style: italic;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.entries-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.entry-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.entry-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #007bff;
}

.entry-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f3f4;
}

.entry-number {
  display: flex;
  align-items: center;
  gap: 8px;
}

.entry-badge {
  background: #007bff;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.entry-number h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.entry-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-row {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.entry-form .field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
}

.entry-form .field-group.field-group-wide {
  flex: 2 1;
}

.entry-form .field-group label {
  font-size: 12px;
  font-weight: 500;
  color: #495057;
  margin-bottom: 2px;
}

.entry-form .field-group input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.2s ease;
  background: #fff;
  box-sizing: border-box;
  height: 36px;
}

.entry-form .field-group input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.entry-form .field-group input::placeholder {
  color: #adb5bd;
}

.remove-btn {
  background: #dc3545;
  color: white;
  border: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.remove-btn:hover {
  background: #c82333;
}

/* Responsive design */
@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }
  
  .add-btn {
    width: 100%;
  }
  
  .entry-card {
    padding: 12px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 8px;
  }
  
  .entry-form .field-group input {
    padding: 6px 10px;
    font-size: 13px;
  }
  
  .entry-number h5 {
    font-size: 13px;
  }
  
  .entry-badge {
    width: 20px;
    height: 20px;
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .entry-card {
    padding: 10px;
  }
  
  .entry-header {
    margin-bottom: 10px;
  }
  
  .entry-form .field-group input {
    padding: 6px 8px;
    font-size: 12px;
  }
  
  .entry-form .field-group label {
    font-size: 11px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DynamicPersonsToVisitTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".dynamic-persons-to-visit-table {\n  margin-bottom: 10px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 10px 0;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.table-header h4 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.add-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.add-btn:hover {\n  background: #218838;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 30px 20px;\n  border: 2px dashed #e9ecef;\n  border-radius: 8px;\n  background: #f8f9fa;\n}\n\n.empty-state p {\n  margin: 0 0 15px 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.table-footer {\n  padding: 15px 20px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  text-align: center;\n}\n\n.hint-text {\n  margin: 0 0 10px 0;\n  color: #6c757d;\n  font-size: 14px;\n  font-style: italic;\n}\n\n.error-text {\n  color: #dc3545;\n  font-size: 12px;\n  margin-top: 4px;\n  display: block;\n}\n\n.entries-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px;\n}\n\n.entry-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 16px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.entry-card:hover {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-color: #007bff;\n}\n\n.entry-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #f1f3f4;\n}\n\n.entry-number {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.entry-badge {\n  background: #007bff;\n  color: white;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.entry-number h5 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.entry-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.form-row {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.entry-form .field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n.entry-form .field-group.field-group-wide {\n  flex: 2;\n}\n\n.entry-form .field-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 2px;\n}\n\n.entry-form .field-group input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  background: #fff;\n  box-sizing: border-box;\n  height: 36px;\n}\n\n.entry-form .field-group input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.entry-form .field-group input::placeholder {\n  color: #adb5bd;\n}\n\n.remove-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background-color 0.2s;\n}\n\n.remove-btn:hover {\n  background: #c82333;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .table-header {\n    flex-direction: column;\n    gap: 10px;\n    align-items: stretch;\n  }\n  \n  .add-btn {\n    width: 100%;\n  }\n  \n  .entry-card {\n    padding: 12px;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .entry-form .field-group input {\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n  \n  .entry-number h5 {\n    font-size: 13px;\n  }\n  \n  .entry-badge {\n    width: 20px;\n    height: 20px;\n    font-size: 11px;\n  }\n}\n\n@media (max-width: 480px) {\n  .entry-card {\n    padding: 10px;\n  }\n  \n  .entry-header {\n    margin-bottom: 10px;\n  }\n  \n  .entry-form .field-group input {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n  \n  .entry-form .field-group label {\n    font-size: 11px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
